import { useRef } from 'react';
import { getStack, getNavStackHandler } from '../../careand-redux/slices/ui/hooks';
import { store } from '../../careand-redux/store';
import { getUnwrappedDispatch } from '../../careand-redux/useAppDispatch';
import { SwipeUpdate, useSwipe, SwipeState } from '../../hooks/useSwipe';
import { Device } from '../../services/Native/Device';

function useLeftEdgeSwipe() {
  const menuOpenSwipeHandler = useRef<SwipeUpdate | undefined>();
  const backSwipeHandler = useRef<SwipeUpdate | undefined>(backSwipeHandlerFunction);

  const leftEdgeSwipeHandler = useRef<SwipeUpdate | undefined>((state) => {
    const operation = getLeftEdgeSwipeOperation();
    const first = 'first' in state ? state.first : false;
    if (state.state === 'recognized' && state.first) {
      if (operation === 'menu') {
        menuOpenSwipeHandler?.current?.(state);
      } else {
        backSwipeHandler?.current?.(state);
      }
      return;
    }
    menuOpenSwipeHandler?.current?.(state);
    backSwipeHandler?.current?.(state);
  });

  const leftEdgeSwipe = useSwipe({
    delta: [5, undefined],
    activationRegion: { maxX: 20 },
    swipeHandler: leftEdgeSwipeHandler,
    extraCondition: () => store.getState().authentication.loggedIn && Device.isMobile(),
    debugName: 'leftEdge',
  });

  return { leftEdgeSwipe, menuOpenSwipeHandler };
}

export function LeftEdgeSwipeContainer({
  children,
}: {
  children: (swipeHandler: ReturnType<typeof useLeftEdgeSwipe>) => JSX.Element | null;
}) {
  const swipeHandler = useLeftEdgeSwipe();

  return children(swipeHandler);
}

function getLeftEdgeSwipeOperation(): 'pop' | 'menu' {
  const stack = getStack('current');
  const hasPrev = store.getState().navigation.stacks[stack].idx > 0;
  return hasPrev ? 'pop' : 'menu';
}

function backSwipeHandlerFunction(state: SwipeState) {
  if (state.state === 'recognized' && state.first) {
    const stack = getStack('current');
    const nav = getNavStackHandler(stack, getUnwrappedDispatch(store.dispatch));
    const hasPrev = store.getState().navigation.stacks[stack].idx > 0;
    if (hasPrev) {
      nav.pop();
    }
  }
}
